import { Controller } from "@hotwired/stimulus"
import { formatElapsed } from "../lib/elapsed_label"

// Same tiering as Kitchen/Service (KitchenTicket.elapsed_label) via the
// shared formatElapsed helper, rather than a third bespoke h/m-only format.
// A shift left open since April was rendering "2613H 13M" — hours never
// rolled over into days. _rail.html.erb pre-renders the same tiering
// server-side for first paint; this has to match exactly or the label
// flashes from one format to the other a second after load.
export default class extends Controller {
  static values = { since: String }

  connect() {
    this.since = new Date(this.sinceValue).getTime()
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() { clearInterval(this.timer) }

  tick() {
    const elapsedSeconds = Math.max(0, Math.floor((Date.now() - this.since) / 1000))
    this.element.textContent = formatElapsed(elapsedSeconds)
  }
}
